var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "m-5 md:m-15 2xl:m-20"
  }, [_c('EvalInProgress', {
    attrs: {
      "evaluation-in-progress": _vm.evaluationInProgress
    },
    on: {
      "massAssignation": function ($event) {
        return _vm.displayAssignTemplate();
      },
      "showPreview": function ($event) {
        _vm.showPreview = true;
      }
    }
  }), _vm._v(" "), _c('mass-template-assignation', {
    attrs: {
      "opened": _vm.massAssignation,
      "template": _vm.massAssignationTemplate
    },
    on: {
      "close": function ($event) {
        _vm.massAssignation = false;
      }
    }
  }), _vm._v(" "), _c('popup', {
    attrs: {
      "opened": _vm.confirmDeleteTemplate > -1
    },
    on: {
      "close": function ($event) {
        _vm.confirmDeleteTemplate = -1;
      }
    }
  }, [_vm.confirmDeleteTemplate == 0 ? _c('div', [_c('div', {
    staticClass: "my-5 xl:my-15"
  }, [_c('h3', {
    staticClass: "mb-5 md:mb-10 2xl:mb-15"
  }, [_vm._v("\n          Supprimer le modèle de page \"" + _vm._s(_vm.templateNameToDelete) + "\"\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "mb-10"
  }, [_c('p', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("\n            Êtes-vous sûr de vouloir supprimer la page \"" + _vm._s(_vm.templateNameToDelete) + "\" ?\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("\n            Cette suppression sera définitive et irrévocable.\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center bg-pink"
  }, [_c('action-button', {
    staticClass: "mr-4",
    attrs: {
      "border-color": "border-pink-600",
      "text-color": "text-pink-600",
      "bg-color": "bg-pink-300",
      "libelle": "ANNULER"
    },
    on: {
      "clickAction": function ($event) {
        _vm.confirmDeleteTemplate = -1;
      }
    }
  }), _vm._v(" "), _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "libelle": "SUPPRIMER",
      "type-shadow": "shadow-pink"
    },
    on: {
      "clickAction": _vm.confirm_delete_template
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _vm.confirmDeleteTemplate == 1 ? _c('div', [_c('h3', {
    staticClass: "w-full text-indigo-600 mt-12 mb-10"
  }, [_vm._v("\n        Le modèle de page \"" + _vm._s(_vm.templateNameToDelete) + "\""), _c('br'), _vm._v("a bien été\n        supprimé !\n      ")]), _vm._v(" "), _c('illustration', {
    staticClass: "w-full m-5",
    attrs: {
      "name": "basket"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.confirmDeleteTemplate == 2 ? _c('div', [_c('div', {
    staticClass: "my-5 xl:my-15"
  }, [_c('h3', {
    staticClass: "mb-5 md:mb-10 2xl:mb-15"
  }, [_vm._v("\n          Supprimer le modèle de page \"" + _vm._s(_vm.templateNameToDelete) + "\"\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('p', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("\n            Êtes-vous sûr de vouloir supprimer le modèle de page \"" + _vm._s(_vm.templateNameToDelete) + "\" ?\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("\n            Cette suppression sera définitive et irrévocable.\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "mb-10"
  }, [_c('p', {
    staticClass: "text-pink-600 text-lg text-center"
  }, [_vm._v("\n            Attention, ce modèle de page est utilisé par\n            " + _vm._s(_vm.listAssignedUsersTemplate.length) + " bénéficiaire"), _vm.listAssignedUsersTemplate.length > 1 ? _c('span', [_vm._v("s")]) : _vm._e(), _vm._v("\n            :\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "text-pink-600 text-lg text-center"
  }, _vm._l(_vm.listAssignedUsersTemplate, function (beneficiary, index) {
    return _c('span', {
      key: beneficiary.id
    }, [index > 0 ? _c('span', [_vm._v("- ")]) : _vm._e(), _vm._v(_vm._s(beneficiary.firstname) + "\n              "), _c('span', {
      staticClass: "uppercase"
    }, [_vm._v(_vm._s(beneficiary.lastname))])]);
  }), 0), _vm._v(" "), _c('p', {
    staticClass: "text-pink-600 text-lg text-center"
  }, [_vm._v("\n            En cas de suppression, le modèle de page \"" + _vm._s(_vm.templatePageToAssignAfterDelete.name) + "\" leur sera attribué.\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center bg-pink"
  }, [_c('action-button', {
    staticClass: "mr-4",
    attrs: {
      "border-color": "border-pink-600",
      "text-color": "text-pink-600",
      "bg-color": "bg-pink-300",
      "libelle": "ANNULER"
    },
    on: {
      "clickAction": function ($event) {
        _vm.confirmDeleteTemplate = -1;
      }
    }
  }), _vm._v(" "), _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "libelle": "SUPPRIMER",
      "type-shadow": "shadow-pink"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.confirm_delete_template(_vm.templatePageToAssignAfterDelete);
      }
    }
  })], 1)])]) : _vm._e()]), _vm._v(" "), _c('deactivate-template-popup', {
    attrs: {
      "confirm-deactivate-template": _vm.confirmDeactivateTemplate,
      "template-name-to-deactivate": _vm.templateNameToDeactivate,
      "list-assigned-users-template": _vm.listAssignedUsersTemplate,
      "template-page-to-assign-after-delete": _vm.templatePageToAssignAfterDelete
    },
    on: {
      "confirm_deactivate_template": function (templatePageToAssignAfterDelete) {
        _vm.confirm_deactivate_template(templatePageToAssignAfterDelete);
      },
      "close": function ($event) {
        _vm.confirmDeactivateTemplate = -1;
      }
    }
  }), _vm._v(" "), _c('activate-template-popup', {
    attrs: {
      "confirm-activate-template": _vm.confirmActivateTemplate,
      "template-name-to-deactivate": _vm.templateNameToDeactivate
    },
    on: {
      "confirm_activate_template": function ($event) {
        return _vm.confirm_activate_template();
      },
      "close": function ($event) {
        _vm.confirmActivateTemplate = -1;
      }
    }
  }), _vm._v(" "), _c('popup', {
    attrs: {
      "opened": _vm.showPreview
    },
    on: {
      "close": function ($event) {
        _vm.showPreview = false;
      }
    }
  }, [_c('div', [_c('h3', {
    staticClass: "mt-10 mb-10 w-full"
  }, [_vm._v("\n        " + _vm._s(_vm.infosPage.libelle_template) + "\n      ")]), _vm._v(" "), _c('list-grid', {
    attrs: {
      "grid": "grid-cols-11",
      "list-items": _vm.template[1].criterions
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('div', {
          staticClass: "ml-2 md:ml-10 col-span-4"
        }, [_vm._v("\n            Intitulé\n          ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-2 hidden md:inline"
        }, [_vm._v("\n            Auto-évaluation\n          ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-2 hidden md:inline"
        }, [_vm._v("\n            Dernière éval.ref\n          ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-2 hidden md:inline"
        }, [_vm._v("\n            Nouvelle éval.ref\n          ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-5 md:hidden"
        }, [_vm._v("\n            Evaluations\n          ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-1 text-center"
        }, [_vm._v("\n            Comm.\n          ")])];
      },
      proxy: true
    }, {
      key: "accordionDescription",
      fn: function (_ref) {
        var num = _ref.num,
          item = _ref.item;
        return [_c('div', {
          staticClass: "row-start-1 row-span-3 md:row-span-1 col-span-4 text-sm ml-2 md:ml-10"
        }, [_vm._v("\n            " + _vm._s(item.description) + "\n          ")]), _vm._v(" "), _c('input-select', {
          staticClass: "col-start-5 col-span-4 row-start-1 md:row-start-auto md:col-span-2",
          attrs: {
            "libelle": "Auto-évaluation",
            "name": num + 'auto_eval',
            "value": _vm.template[0].criterions[Math.floor(Math.random() * Math.floor(_vm.template[0].criterions.length))].value,
            "datas": _vm.template[0].criterions
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "col-start-5 col-span-4 row-start-2 md:row-start-auto md:col-span-2",
          attrs: {
            "libelle": "Dernière éval.ref",
            "name": num + 'derniere_eval',
            "disabled": true,
            "value": _vm.template[0].criterions[Math.floor(Math.random() * Math.floor(_vm.template[0].criterions.length))].value
          }
        }), _vm._v(" "), _c('input-select', {
          staticClass: "col-start-5 col-span-4 row-start-3 md:row-start-auto md:col-span-2",
          attrs: {
            "libelle": "Nouvelle éval.ref",
            "name": num + 'nouvelle_eval',
            "necessary": true,
            "value": _vm.template[0].criterions[Math.floor(Math.random() * Math.floor(_vm.template[0].criterions.length))].value,
            "datas": _vm.template[0].criterions
          }
        }), _vm._v(" "), _c('icon-comment', {
          staticClass: "col-span-1 row-start-2 md:row-start-auto place-self-center"
        })];
      }
    }])
  }), _vm._v(" "), _vm.template[2] && _vm.template[2].isDisplayed ? _c('input-text-area', {
    staticClass: "px-10 mt-10",
    attrs: {
      "name": "comment",
      "libelle": "Commentaire général",
      "value": "Exemple de commentaire"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _vm.isEditable ? _c('div', [_c('div', {
    staticClass: "flex justify-center"
  }, [_c('input-title', {
    staticClass: "mb-5 md:mb-15 2xl:mb-20 w-3/4",
    attrs: {
      "name": "title",
      "value": _vm.infosPage.libelle_template,
      "disabled": !_vm.$can(_vm.constants.PERMISSION_MODELE_DE_PAGE_EDITER) || this.evaluationInProgress,
      "error": true,
      "maxlength": 40
    },
    on: {
      "input": function (value) {
        _vm.infosPage.libelle_template = value;
      },
      "valid": function (title) {
        _vm.SET_NAME_TEMPLATE_IN_LIST([_vm.infosPage.id_template, title]);
      }
    }
  })], 1), _vm._v(" "), _c('list-buttons', {
    attrs: {
      "evaluation-in-progress": _vm.evaluationInProgress,
      "is-active": _vm.infosPage.is_active,
      "can-delete": ""
    },
    on: {
      "preview": function () {
        _vm.showPreview = true;
      },
      "deactivateTemplate": function ($event) {
        return _vm.displayConfirmDeactivateTemplate();
      },
      "activateTemplate": function ($event) {
        return _vm.displayConfirmActivateTemplate();
      },
      "confirmDelete": function () {
        _vm.displayConfirmDeleteTemplate();
      },
      "assignTemplate": function ($event) {
        return _vm.displayAssignTemplate();
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col"
  }, [_c('div', {
    staticClass: "text-base mb-5 uppercase"
  }, [_vm._v("\n        " + _vm._s(_vm.template[0].libelle) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-12 gap-x-4 gap-y-10 place-content-center mb-15"
  }, [_vm._l(_vm.template[0].criterions, function (criteria, i) {
    return _c('div', {
      key: i,
      staticClass: "relative col-span-full lg:col-span-3"
    }, [_c('input-text', {
      attrs: {
        "name": "comprehension_orale_derniere_eval",
        "libelle": "",
        "value": criteria.value,
        "disabled": !_vm.$can(_vm.constants.PERMISSION_MODELE_DE_PAGE_EDITER)
      },
      on: {
        "input": function (newValue) {
          _vm.$set(criteria, 'value', newValue);
        }
      }
    }), _vm._v(" "), _vm.$can(_vm.constants.PERMISSION_MODELE_DE_PAGE_EDITER) ? _c('div', {
      staticClass: "absolute flex cursor-pointer bottom-8/12 left-11/12 p-2 2xl:p-2.5 items-center text-pink-600 bg-pink-100 border border-pink-600 border-opacity-25 rounded-full",
      on: {
        "click": function ($event) {
          return _vm.deleteCriterion(0, i);
        }
      }
    }, [_c('icon', {
      staticClass: "h-2 w-2 2xl:h-2.5 2xl:w-2.5",
      attrs: {
        "name": "close"
      }
    })], 1) : _vm._e()], 1);
  }), _vm._v(" "), _vm.$can(_vm.constants.PERMISSION_MODELE_DE_PAGE_EDITER) ? _c('div', {
    staticClass: "col-start-1 col-span-full w-max-content w-max cursor-pointer flex hover:font-medium",
    on: {
      "click": function ($event) {
        return _vm.addCriterion(0);
      }
    }
  }, [_c('span', {
    staticClass: "plus-button 2xl:h-10 2xl:w-10"
  }, [_c('icon', {
    attrs: {
      "name": "plus"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-base text-gray-600 ml-3 mt-1.5 flex-initial"
  }, [_vm._v("\n            Ajouter un critère\n          ")])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "text-base mb-8 uppercase",
    attrs: {
      "id": "title1"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.template[1].libelle) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mb-15"
  }, [_vm.template.length > 0 ? _c('draggable', _vm._b({
    style: {
      'cursor:grab;': _vm.$can(_vm.constants.PERMISSION_MODELE_DE_PAGE_EDITER)
    },
    on: {
      "start": function ($event) {
        _vm.drag = true;
      },
      "end": function ($event) {
        _vm.drag = false;
      }
    },
    model: {
      value: _vm.template[1].criterions,
      callback: function ($$v) {
        _vm.$set(_vm.template[1], "criterions", $$v);
      },
      expression: "template[1].criterions"
    }
  }, 'draggable', _vm.dragOptions, false), [_c('transition-group', {
    attrs: {
      "enter-active-class": "ease-in duration-1000",
      "enter-class": "bg-indigo-300 border-0 rounded-xl",
      "enter-to-class": "bg-none border-0 rounded-xl",
      "leave-active-class": "linear duration-1000",
      "leave-class": "h-20 opacity-100",
      "leave-to-class": "h-0 opacity-0",
      "tag": "div"
    }
  }, _vm._l(_vm.template[1].criterions, function (criteria, j) {
    return _c('div', {
      key: criteria.location,
      staticClass: "bg-white h-16 lg:h-24 2xl:h-32 w-full border rounded-lg shadow-md shadow-gray-600 mb-5 grid grid-cols-12 items-center",
      style: _vm.displayValider === -1 ? 'cursor:grab' : '',
      attrs: {
        "id": 'intitule' + j
      }
    }, [_c('div', {
      staticClass: "col-span-1 justify-self-center"
    }, [_c('icon', {
      staticClass: "text-indigo-600 w-5 h-5",
      attrs: {
        "name": "move"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-span-3 md:col-span-2 ml-2 md:ml-0"
    }, [_vm.displayValider === j ? _c('input-text', {
      attrs: {
        "name": "libelle",
        "libelle": "",
        "value": criteria.libelle
      },
      on: {
        "input": function (newValue) {
          _vm.$set(criteria, 'libelle', newValue);
        }
      }
    }) : _c('p', {
      staticClass: "overflow-hidden max-h-15 description text-base text-left"
    }, [_vm._v("\n                  " + _vm._s(criteria.libelle) + "\n                ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-span-1 justify-self-center border-solid border-r-2 border-indigo-500 h-4/6"
    }), _vm._v(" "), _c('div', {
      staticClass: "col-span-6 md:col-span-7 relative font-normal flex justify-between items-center"
    }, [_vm.displayValider === j ? _c('input-text-area', {
      attrs: {
        "name": "description",
        "libelle": "",
        "value": criteria.description
      },
      on: {
        "input": function (newValue) {
          _vm.$set(criteria, 'description', newValue);
        }
      }
    }) : _c('p', {
      staticClass: "overflow-hidden max-h-15 description text-base font-light"
    }, [_vm._v("\n                  " + _vm._s(criteria.description) + "\n                ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.displayValider === j,
        expression: "displayValider === j"
      }],
      staticClass: "cursor-pointer text-teal-400 ml-5",
      on: {
        "click": function ($event) {
          $event.preventDefault();
          return _vm.validEdit.apply(null, arguments);
        }
      }
    }, [_c('icon', {
      staticClass: "text-teal-600",
      attrs: {
        "name": "checkmark-circle"
      }
    })], 1)], 1), _vm._v(" "), _c('span', {
      staticClass: "col-span-1 justify-self-start"
    }, [_vm.$can(_vm.constants.PERMISSION_MODELE_DE_PAGE_EDITER) ? _c('span', {
      staticClass: "cursor-pointer",
      on: {
        "click": [function ($event) {
          return _vm.displayDropdownMenu(j);
        }, function ($event) {
          $event.stopPropagation();
        }]
      }
    }, [_c('div', {
      staticClass: "p-3"
    }, [_c('icon', {
      staticClass: "text-pink-600",
      attrs: {
        "name": "more-vertical"
      }
    })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.dropDownMenu === j,
        expression: "dropDownMenu === j"
      }, {
        name: "click-outside",
        rawName: "v-click-outside",
        value: _vm.forceHide,
        expression: "forceHide"
      }],
      staticClass: "z-20 absolute dropdown-menu mt-28 right-15 w-max-content w-max ml-auto rounded-md bg-white shadow-md shadow-gray-600 text-sm"
    }, [_c('div', {
      staticClass: "mx-5 my-3 text-left"
    }, [_c('div', {
      staticClass: "flex flex-col"
    }, [_c('div', {
      staticClass: "flex cursor-pointer pt-1 text-gray-600 hover:text-gray-900"
    }, [_c('button', {
      on: {
        "click": function ($event) {
          return _vm.editCriterion(j);
        }
      }
    }, [_vm._v("\n                        Modifier\n                      ")])]), _vm._v(" "), _c('div', {
      staticClass: "flex cursor-pointer pt-1 text-gray-600 hover:text-gray-900"
    }, [_c('button', {
      on: {
        "click": function ($event) {
          return _vm.cloneCriterion(1, j);
        }
      }
    }, [_vm._v("\n                        Dupliquer\n                      ")])]), _vm._v(" "), _c('div', {
      staticClass: "flex cursor-pointer pt-1 text-gray-600 hover:text-gray-900"
    }, [_c('button', {
      on: {
        "click": function ($event) {
          return _vm.deleteCriterion(1, j);
        }
      }
    }, [_vm._v("\n                        Supprimer\n                      ")])])])])])]);
  }), 0)], 1) : _vm._e(), _vm._v(" "), _vm.$can(_vm.constants.PERMISSION_MODELE_DE_PAGE_EDITER) ? _c('div', {
    staticClass: "w-max-content w-max cursor-pointer flex hover:font-medium mt-10",
    on: {
      "click": function ($event) {
        return _vm.addCriterion(1);
      }
    }
  }, [_c('span', {
    staticClass: "plus-button 2xl:h-10 2xl:w-10"
  }, [_c('icon', {
    attrs: {
      "name": "plus"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-base text-gray-600 ml-3 mt-1.5 flex-initial"
  }, [_vm._v("\n            Ajouter un intitulé\n          ")])]) : _vm._e()], 1), _vm._v(" "), _vm.template[2] ? _c('div', {
    staticClass: "text-base mb-8 uppercase",
    attrs: {
      "id": "title2"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.template[2].libelle) + "\n      ")]) : _vm._e(), _vm._v(" "), _vm.template[2] ? _c('checkbox-indigo', {
    attrs: {
      "name": "displayCommentaire",
      "libelle": "Afficher le champ commentaire",
      "value": _vm.template[2].isDisplayed
    },
    on: {
      "input": function (newValue) {
        _vm.template[2].isDisplayed = newValue;
      }
    }
  }) : _vm._e()], 1)], 1) : _c('div', [_c('div', {
    staticClass: "mb-5 md:mb-15 2xl:mb-20"
  }, [_c('h3', [_vm._v("\n        " + _vm._s(this.infosPage.libelle_template) + "\n      ")])]), _vm._v(" "), _c('list-buttons', {
    attrs: {
      "evaluation-in-progress": _vm.evaluationInProgress,
      "is-active": _vm.infosPage.is_active,
      "can-delete": false
    },
    on: {
      "preview": function () {
        _vm.showPreview = true;
      },
      "deactivateTemplate": function ($event) {
        return _vm.displayConfirmDeactivateTemplate();
      },
      "assignTemplate": function ($event) {
        return _vm.displayAssignTemplate();
      },
      "activateTemplate": function ($event) {
        return _vm.displayConfirmActivateTemplate();
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mx-15"
  }, [_c('h3', {
    staticClass: "text-lg text-gray-600"
  }, [_vm._v("\n        Le modèle de page " + _vm._s(this.infosPage.libelle_template) + " n'est pas\n        modifiable."), _c('br'), _vm._v("\n        Vous pouvez simplement\n        "), _vm.$can(_vm.constants.PERMISSION_MODELE_DE_PAGE_DESACTIVER) ? _c('span', [_vm._v("activer ou désactiver")]) : _c('span', [_vm._v("visualiser")]), _vm._v(" le modèle de page.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "my-15 flex justify-center"
  }, [_c('illustration', {
    attrs: {
      "name": "notAllowed"
    }
  })], 1)])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }